import TextEditorMinimal from '@/components/commons/minimal-tiptap/minimal-editor';
import {
  RichTextElementDataType,
  RichTextSubtitleElementDataType,
} from '@/components/sections/builder/elements/body/rich-text/types';
import InputSelect from '@/components/sections/builder/settings/input-select';
import { ElementProps } from '@/components/sections/builder/types';
import { useBuilderStore } from '@/stores/builder';
import clsx from 'clsx';
import { Type } from 'lucide-react';
import { shallow } from 'zustand/shallow';

const defaultData: RichTextSubtitleElementDataType = {
  name: 'Subtitle',
  label: 'Give customers details about the banner image(s) or content on the template.',
  textStyle: 'subtitle',
  padding: {
    bottom: 16,
    top: 0,
    left: 0,
    right: 0,
  },
  subtitleSize: 'small',
};

export const ElementContent = ({ element }: ElementProps) => {
  const data = (element.data || defaultData) as RichTextSubtitleElementDataType;
  const parentData = element.parentData as RichTextElementDataType;

  return (
    <div className='break-words'>
      <p
        className={clsx(
          'subtitle-padding text_color_container inline-block w-full text-left text-2xl font-extralight leading-relaxed text-white @sm:text-2xl md:text-3xl lg:max-w-6xl lg:text-4xl',

          parentData.contentAlign === 'center' && 'md:text-center',
          parentData.contentAlign === 'right' && 'md:text-right',
          parentData.contentAlignMobile === 'left' && 'text-left',
          parentData.contentAlignMobile === 'center' && 'text-center',
          parentData.contentAlignMobile === 'right' && 'text-right',
          data.subtitleSize === 'large' && 'text-4xl @sm:text-4xl md:text-5xl lg:text-6xl',
          data.subtitleSize === 'medium' && 'text-3xl @sm:text-3xl md:text-4xl lg:text-5xl',
          data.subtitleSize === 'small' && 'text-2xl @sm:text-2xl md:text-3xl lg:text-4xl'
        )}
        data-animation='true'
        dangerouslySetInnerHTML={{ __html: data.label }}
      />

      <style jsx>
        {`
          @media (min-width: 1024px) {
            .subtitle-padding {
              padding-top: ${data.padding?.top || 0}px;
              padding-bottom: ${data.padding?.bottom || 0}px;
              padding-left: ${data.padding?.left || 0}px;
              padding-right: ${data.padding?.right || 0}px;
            }
          }

          .text_color_container {
            color: ${parentData.containerColorScheme?.text || '#6b7280'};
          }
        `}
      </style>
    </div>
  );
};

export const ElementPreviewIcon = Type;
export function ElementSetting({ element }: ElementProps) {
  const builder = useBuilderStore(
    (state) => ({
      setChildData: state.setChildData,
      clearSelected: state.clearSelected,
    }),
    shallow
  );

  const data = element.data as RichTextSubtitleElementDataType;

  return (
    <div>
      <div className=''>Text</div>
      <TextEditorMinimal
        placeholder='Label'
        onChange={(value) =>
          builder.setChildData(element.parentId as string, element.id, {
            label: value,
          })
        }
        value={data.label}
        className='mb-4 w-full '
        output='html'
        editorProps={{
          attributes: {
            class: 'prose lg:prose-lg prose-blue dark:prose-invert p-2',
          },
        }}
        editable
      />

      <div className='mb-3 grid grid-cols-2 items-center gap-2'>
        <h4 className=''>Subtitle Size</h4>
        <InputSelect
          defaultValue={data.subtitleSize || 'small'}
          options={[
            { label: 'Small', value: 'small' },
            { label: 'Medium', value: 'medium' },
            { label: 'Large', value: 'large' },
          ]}
          onChange={(v) =>
            builder.setChildData(element.parentId as string, element.id, {
              subtitleSize: v,
            })
          }
        />
      </div>
    </div>
  );
}

const Subtitle = {
  type: 'rich_text_subtitle',
  group: 'rich_text',
  defaultData,
  Element: ElementContent,
  Setting: ElementSetting,
  PreviewIcon: ElementPreviewIcon,
  Icon: ElementPreviewIcon,
  childs: [],
};

export default Subtitle;
